import { store } from './store.js';
/**
 * PROBLEM LOGIC - Detectimáticas de 1º
 * Gestión de la generación, visualización y resolución de problemas.
 */

const ProblemLogic = {
    init() {
        console.log('📝 Inicializando ProblemLogic...');
    },

    async generateProblems(config) {
        console.log('📊 Generando problemas...', config);

        // 🟢 INTERCEPCIÓN PARA MODO IA (SOLO SI SE ACTIVA EXPLÍCITAMENTE)
        const isAIMode = config.mode === 'online';

        if (isAIMode && window.generateProblemsWithAgents) {
            console.log('🤖 Usando Orquestador (Modo AI Online activado)...');
            return await window.generateProblemsWithAgents(config);
        }

        console.log('📑 Usando cargador Excel (Baseline)...');

        if (!window.ExcelLoader || !window.ExcelLoader.isLoaded) {
            if (window.ExcelLoader) {
                const loaded = await window.ExcelLoader.loadProblems();
                if (!loaded) return [];
            } else {
                return [];
            }
        }

        const levelMapping = {
            1: 'beginner', 2: 'advanced', 3: 'expert',
            'beginner': 'beginner', 'advanced': 'advanced', 'expert': 'expert'
        };
        const level = levelMapping[config.level] || 'beginner';

        const typeMapping = {
            'sum': 'sum', 'suma': 'sum', 'addition': 'sum',
            'subtraction': 'subtraction', 'resta': 'subtraction', 'sub': 'subtraction'
        };
        const problemType = typeMapping[config.problemType] || null;

        const problems = window.ExcelLoader.getProblems(config.context, level, problemType, 5);
        console.log(`✅ ${problems.length} problemas obtenidos`);
        return problems;
    },

    displayProblem(index) {
        const state = store.state;
        if (!state || !state.problems || state.problems.length === 0) return;

        const problem = state.problems[index];
        if (!problem) return;

        state.currentProblem = index;

        // Personajes (Mentor)
        if (window.DetectiveMentor) {
            if (index === 0) window.DetectiveMentor.randomizeCharacter();
            else window.DetectiveMentor.alternateCharacter();
        }

        // UI Updates
        const counterEl = document.getElementById('problemCounterText');
        if (counterEl) {
            const totalProblems = state.problems.length;
            counterEl.textContent = `Problema ${index + 1} de ${totalProblems}`;
        }

        const contextBannerIcon = document.querySelector('.context-banner-icon');
        const contextBannerTitle = document.getElementById('contextBannerTitle');

        const contextEmojis = {
            'cumpleanos': '🎂', 'feria': '🎪', 'circo': '🎪', 'navidad': '🎄',
            'halloween': '🎃', 'fruteria': '🍎', 'supermercado': '🛒',
            'panaderia': '🥖', 'jugueteria': '🧸', 'libreria': '📚',
            'granja': '🐄', 'playa': '🏖️', 'bosque': '🌲', 'huerto': '🥕',
            'acuario': '🐠', 'parque': '🎠', 'cocina': '👨‍🍳', 'dormitorio': '🛏️'
        };

        if (contextBannerIcon) contextBannerIcon.textContent = contextEmojis[problem.contextId] || '🎯';
        if (contextBannerTitle) {
            if (typeof problem.contextName === 'string') {
                contextBannerTitle.textContent = problem.contextName;
            } else if (problem.contextName) {
                contextBannerTitle.textContent = problem.contextName[window.currentLanguage] || problem.contextName['es-ES'] || Object.values(problem.contextName)[0] || 'Misión';
            } else {
                contextBannerTitle.textContent = 'Misión';
            }
        }

        const statementText = document.getElementById('statementText');
        const questionText = document.getElementById('questionText');
        if (statementText) {
            let rawText = '';
            if (typeof problem.statement === 'string') {
                rawText = problem.statement;
            } else if (problem.statement) {
                rawText = problem.statement[window.currentLanguage] || problem.statement['es-ES'] || Object.values(problem.statement)[0] || '';
            }
            // UX-03: Fragmentar enunciado separando por puntos y el inicio de pregunta (¿)
            let formattedText = rawText.replace(/\.\s+/g, '.<br><br>');
            // Evitar acumulación de <br> antes de la pregunta, dejando justo el 50% del espacio que había
            formattedText = formattedText.replace(/(?:<br>)*\s*(¿)/g, '<br><span style="display:block; margin-top:0.5em;"></span>$1');
            statementText.innerHTML = formattedText;
        }
        if (questionText) questionText.textContent = problem.question;

        // Imagen del problema
        const imageContainer = document.getElementById('problemImageContainer');
        const imageElement = document.getElementById('problemImage');
        if (problem.images && problem.images.length > 0) {
            if (imageContainer) imageContainer.style.display = 'flex';
            if (imageElement) {
                imageElement.src = problem.images[0];
                imageElement.style.display = 'block';
            }
            
            // UX: Ampliar imagen al hacer clic
            if (imageElement) {
                imageElement.onclick = () => {
                    if (window.Swal) {
                        Swal.fire({
                            imageUrl: problem.images[0],
                            imageAlt: 'Ilustración del problema',
                            showCloseButton: true,
                            showConfirmButton: false,
                            width: '100%',
                            padding: '0',
                            background: 'transparent',
                            backdrop: `rgba(0,0,0,0.9)`,
                            customClass: {
                                popup: 'swal-fullscreen-popup',
                                image: 'swal-fullscreen-image'
                            }
                        });
                    }
                };
            }
        } else {
            if (imageContainer) imageContainer.style.display = 'none';
        }

        // Reset wizard
        if (window.resetWizard) window.resetWizard();

        // [NEW] Start tracking time for this problem
        if (window.GamificationService) {
            const probId = problem.id || `prob_${Date.now()}`;
            window.GamificationService.startProblem(probId);
        }

        // Update nav buttons locally if they exist
        if (window.updateNavigationButtons) window.updateNavigationButtons();

        // Audio buttons
        if (window.addSafeAudioButtons) setTimeout(window.addSafeAudioButtons, 50);
    },

    readProblemAloud() {
        const state = store.state;
        const problem = state.problems[state.currentProblem];
        if (problem && window.speak) {
            let statement = '';
            if (typeof problem.statement === 'string') {
                statement = problem.statement;
            } else if (problem.statement) {
                statement = problem.statement[window.currentLanguage] || problem.statement['es-ES'] || Object.values(problem.statement)[0] || '';
            }
            window.speak(statement, window.currentLanguage);
        }
    },

    checkAnswer() {
        const state = store.state;
        const answerInput = document.getElementById('studentAnswer');
        if (!answerInput) return;

        const userAnswer = parseInt(answerInput.value);
        const problem = state.problems[state.currentProblem];
        const correctAnswer = problem.solution.answer;

        const isCorrect = userAnswer === correctAnswer;

        // Feedback
        const feedbackDiv = document.getElementById('answerFeedback');
        if (feedbackDiv) {
            const feedbackText = document.getElementById('feedbackText');
            feedbackDiv.classList.remove('hidden', 'correct', 'incorrect');
            if (isCorrect) {
                feedbackDiv.classList.add('correct');
                if (feedbackText) feedbackText.textContent = '¡Correcto! Bien hecho.';
                if (window.SoundService) window.SoundService.playSuccess();
                state.score++;
                if (window.SessionManager && problem.id) {
                    window.SessionManager.recordSolvedProblem(problem.id);
                }
            } else {
                feedbackDiv.classList.add('incorrect');
                if (feedbackText) feedbackText.textContent = `Incorrecto. La respuesta correcta es ${correctAnswer}.`;
                if (window.SoundService) window.SoundService.playError();
            }
        }

        state.answers[state.currentProblem] = { userAnswer, isCorrect };
    },

    setupEventListeners() {
        const nextBtn = document.getElementById('nextProblemBtn');
        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                store.state.currentProblem++;
                // Vamos directamente al siguiente problema (la intro solo se muestra al inicio de la misión)
                if (window.showProblemScreen) window.showProblemScreen();
                else if (window.showNarrativeIntro) window.showNarrativeIntro();
            });
        }

        const finishBtn = document.getElementById('finishSessionBtn');
        if (finishBtn) {
            finishBtn.addEventListener('click', () => {
                if (window.showSummaryScreen) window.showSummaryScreen();
            });
        }

        const readBtn = document.getElementById('readProblemBtn');
        if (readBtn) {
            readBtn.addEventListener('click', () => this.readProblemAloud());
        }

        // UX-03: Always visible read aloud button
        const readAloudBtn = document.getElementById('readAloudBtn');
        if (readAloudBtn) {
            readAloudBtn.addEventListener('click', () => this.readProblemAloud());
        }
    }
};

// Aliases
window.generateProblemsAsync = (cfg) => ProblemLogic.generateProblems(cfg);
window.displayProblem = (idx) => ProblemLogic.displayProblem(idx);
window.readProblemAloud = () => ProblemLogic.readProblemAloud();
window.checkAnswer = () => ProblemLogic.checkAnswer();
window.setupProblemEventListeners = () => ProblemLogic.setupEventListeners();
